<template lang="">
<div>
  <!-------------------------------- Bloc Personnes rencontrées -------------------------------->
  <v-col cols="12" sm="10" class="pb-0 mt-10">
    <v-toolbar color="#0B87BA" flat dense>
      <v-col cols="6" lg="6" xl="2" class="pa-0 font_color text-left">
        PERSONNES RENCONTREES
      </v-col>
      <v-col cols="6" lg="6" xl="4" offset-xl="6" class="pa-0 text-right">
        <v-btn
          v-if="mode !== 'visualisation'"
          :disabled="disabledExisting"
          class="btnBold mr-2"
          color="#FF9900"
          dark rounded
          @click="dialogExisting = true"
        >
          <v-icon left>fa fa-plus</v-icon>
          <div class="font-small">Contact(s) existant(s)</div>
        </v-btn>
        <v-btn
          v-if="mode !== 'visualisation'"
          :disabled="disabled"
          class="btnBold"
          color="#FF9900"
          dark rounded
          @click="dialog = true"
        >
          <v-icon left>fa fa-plus</v-icon>
          <div class="font-small">Nouveau contact</div>
        </v-btn>
      </v-col>
    </v-toolbar>
  </v-col>

  <!-- ── Modal : Contacts existants ─────────────────────────────── -->
  <v-dialog v-model="dialogExisting" max-width="720">
    <v-card class="cmodal-card">

      <div class="cmodal-header">
        <div class="cmodal-header__left">
          <span class="cmodal-title">Contacts existants</span>
          <span class="selection-badge">{{ nbcontactsSelected }}&thinsp;/&thinsp;4</span>
        </div>
        <v-btn icon dark small @click="dialogExisting = false">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </div>

      <v-card-text class="pa-5">
        <p v-if="contacts.length === 0" class="no-contacts">
          Aucun contact disponible pour cette entreprise.
        </p>
        <div v-else class="contacts-grid">
          <div
            v-for="contact in contacts"
            :key="contact.id_personne"
            class="contact-card"
            :class="{ 'contact-card--selected': contact.value }"
            @click="contact.value = !contact.value; nbcontacts()"
          >
            <div class="contact-card__avatar" :style="{ background: avatarColor(contact) }">
              {{ initials(contact) }}
            </div>
            <v-tooltip bottom :disabled="contact.nom_prenom.length <= 20">
              <template v-slot:activator="{ on }">
                <div class="contact-card__name" v-on="on">{{ contact.nom_prenom }}</div>
              </template>
              <span>{{ contact.nom_prenom }}</span>
            </v-tooltip>
            <v-icon v-if="contact.value" class="contact-card__check" small color="#0B87BA">
              mdi-check-circle
            </v-icon>
          </div>
        </div>
      </v-card-text>

      <v-divider />

      <v-card-actions class="pa-4">
        <v-spacer />
        <v-btn text class="mr-2" @click="dialogExisting = false">Annuler</v-btn>
        <v-btn
          :disabled="disabledCheckbox || nbcontactsSelected === 0"
          color="#FF9900"
          dark rounded depressed
          @click="submitExistingContact"
        >
          <v-icon left small>mdi-plus</v-icon>
          Ajouter la sélection
        </v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>

  <!-- ── Modal : Nouveau contact ────────────────────────────────── -->
  <v-dialog v-model="dialog" max-width="540">
    <v-card class="cmodal-card">

      <div class="cmodal-header">
        <span class="cmodal-title">Nouveau contact</span>
        <v-btn icon dark small @click="dialog = false">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </div>

      <v-card-text class="pa-5">
        <form @submit.prevent="submit">

          <!-- Civilité -->
          <div class="field-group mb-5">
            <div class="field-label">Civilité <span class="required">*</span></div>
            <div class="civilite-toggle mt-1">
              <button
                type="button"
                class="civilite-btn"
                :class="{ 'civilite-btn--active': personne.civilite === 'M.' }"
                @click="personne.civilite = 'M.'"
              >M.</button>
              <button
                type="button"
                class="civilite-btn"
                :class="{ 'civilite-btn--active': personne.civilite === 'MME.' }"
                @click="personne.civilite = 'MME.'"
              >Mme</button>
            </div>
            <div class="error-msg" v-if="$v.personne.civilite.$error && !$v.personne.civilite.required">
              Renseignez la civilité.
            </div>
          </div>

          <!-- Nom / Prénom -->
          <v-row dense>
            <v-col cols="12" sm="6">
              <div class="field-label">Nom <span class="required">*</span></div>
              <v-text-field
                v-model="personne.nom"
                outlined dense
                hide-details="auto"
                :error-messages="nomErrors"
              />
            </v-col>
            <v-col cols="12" sm="6">
              <div class="field-label">Prénom <span class="required">*</span></div>
              <v-text-field
                v-model="personne.prenom"
                outlined dense
                hide-details="auto"
                :error-messages="prenomErrors"
              />
            </v-col>
          </v-row>

          <!-- Fonction / Email -->
          <v-row dense class="mt-3">
            <v-col cols="12" sm="6">
              <div class="field-label">Fonction</div>
              <v-text-field v-model="personne.fonction" outlined dense hide-details />
            </v-col>
            <v-col cols="12" sm="6">
              <div class="field-label">Email <span class="required">*</span></div>
              <v-text-field
                v-model="personne.email"
                outlined dense
                hide-details="auto"
                :error-messages="emailErrors"
              />
            </v-col>
          </v-row>

          <!-- Téléphone -->
          <v-row dense class="mt-3">
            <v-col cols="12" sm="6">
              <div class="field-label">Téléphone <span class="required">*</span></div>
              <v-text-field
                v-model="personne.telephone"
                outlined dense
                hide-details="auto"
                maxlength="10"
                :error-messages="telephoneErrors"
              />
            </v-col>
          </v-row>

          <v-divider class="my-5" />

          <div class="d-flex justify-end">
            <v-btn text class="mr-2" @click="dialog = false">Annuler</v-btn>
            <v-btn
              color="#FF9900"
              dark rounded depressed
              type="submit"
              :disabled="disabled"
            >
              <v-icon left small>mdi-plus</v-icon>
              Ajouter ce contact
            </v-btn>
          </div>

        </form>
      </v-card-text>

    </v-card>
  </v-dialog>

  <!-- ── Modal : Suppression ────────────────────────────────────── -->
  <Popup
    :dialog="dialogDelete"
    text="Supprimer cette personne ?"
    actions=""
    heightProp=""
    widthProp=""
    @emitDialog="dialogDelete = $event"
    showClose="false"
  >
    <v-card-actions class="mb-10">
      <v-btn class="actions" color="#0B87BA" width="100px" large dark rounded @click="deleteItemConfirm">Oui</v-btn>
      <v-btn class="actions mr-10" color="#0B87BA" width="100px" large dark rounded @click="closeDelete">Non</v-btn>
    </v-card-actions>
  </Popup>

  <!-- ── Tableau des personnes ──────────────────────────────────── -->
  <v-col cols="12" sm="10" class="pb-0 mt-10">
    <v-data-table
      v-if="personnes.length > 0"
      :headers="headers"
      :items="personnes"
      :items-per-page="5"
      hide-default-footer
      class="elevation-1"
    >
      <template v-if="mode !== 'visualisation'" v-slot:item.actions="{ item }">
        <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
      </template>
    </v-data-table>
  </v-col>

</div>
</template>

<script>
import {
  required,
  minLength,
  maxLength,
  email,
  numeric,
} from "vuelidate/lib/validators";
import Popup from "@/components/shared/Popup";
import api from "../../api/personne";

export default {
  props: {
    personnes: {
      type: Array,
      default: () => [],
    },
    mode: [String],
  },
  components: { Popup },
  data() {
    return {
      headers: [
        { text: 'Civilité', align: 'start', value: 'civilite', sortable: false },
        { text: 'Nom', value: 'nom', sortable: false },
        { text: 'Prenom', value: 'prenom', sortable: false },
        { text: 'Fonction', value: 'fonction', sortable: false },
        { text: 'Email', value: 'email', sortable: false },
        { text: 'Telephone', value: 'telephone', sortable: false },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      editedIndex: -1,
      dialogDelete: false,
      dialogExisting: false,
      disabled: false,
      disabledExisting: false,
      disabledCheckbox: false,
      dialog: false,
      personne: {
        civilite: "",
        nom: "",
        prenom: "",
        email: "",
        telephone: "",
        fonction: "",
        menu: false,
      },
      contacts: [],
      nbcontactsSelected: 0,
      personneToAdd: [],
    };
  },
  validations: {
    personne: {
      nom: { required, minLength: minLength(2), maxLength: maxLength(50) },
      prenom: { required, minLength: minLength(2), maxLength: maxLength(50) },
      civilite: { required },
      email: { required, email },
      telephone: { required, numeric, minLength: minLength(10), maxLength: maxLength(10) },
    },
  },
  computed: {
    nomErrors() {
      if (!this.$v.personne.nom.$dirty) { return []; }
      if (!this.$v.personne.nom.required) { return ['Renseigner le nom.']; }
      if (!this.$v.personne.nom.minLength) { return ['2 caractères minimum.']; }
      if (!this.$v.personne.nom.maxLength) { return ['50 caractères maximum.']; }
      return [];
    },
    prenomErrors() {
      if (!this.$v.personne.prenom.$dirty) { return []; }
      if (!this.$v.personne.prenom.required) { return ['Renseigner le prénom.']; }
      if (!this.$v.personne.prenom.minLength) { return ['2 caractères minimum.']; }
      if (!this.$v.personne.prenom.maxLength) { return ['50 caractères maximum.']; }
      return [];
    },
    emailErrors() {
      if (!this.$v.personne.email.$dirty) { return []; }
      if (!this.$v.personne.email.required) { return ["Renseignez l'email."]; }
      if (!this.$v.personne.email.email) { return ['Adresse email invalide.']; }
      return [];
    },
    telephoneErrors() {
      if (!this.$v.personne.telephone.$dirty) { return []; }
      if (!this.$v.personne.telephone.required) { return ['Renseigner le téléphone.']; }
      if (!this.$v.personne.telephone.numeric) { return ['Chiffres uniquement.']; }
      if (!this.$v.personne.telephone.minLength || !this.$v.personne.telephone.maxLength) { return ['10 chiffres requis.']; }
      return [];
    },
  },
  watch: {
    async personnes() {
      await this.getContactEntreprise("", this.$route.params.id_entreprise, 0, "nom", "ASC");
      this.disableButton();
    },
  },
  methods: {
    initials(contact) {
      return ((contact.prenom?.[0] ?? '') + (contact.nom?.[0] ?? '')).toUpperCase();
    },
    avatarColor(contact) {
      const palette = ['#0B87BA', '#1a7a9e', '#2d8f7b', '#1e88e5', '#5e35b1', '#e67e22'];
      return palette[(contact.nom?.codePointAt(0) ?? 0) % palette.length];
    },
    async getContactEntreprise(query, id_client, page, column, order) {
      const contacts = await api.getAllEntrepriseContacts(query, id_client, page, column, order);
      contacts.data.personne.rows.forEach((personne) => {
        personne["nom_prenom"] = personne["prenom"] + ' ' + personne["nom"];
      });
      this.contacts = contacts.data.personne.rows;
      if (this.contacts.length === 0) {
        this.disabledExisting = true;
      }
      this.contacts.forEach((contact) => {
        this.personnes.forEach((personne) => {
          if (personne.id_personne === contact.id_personne) {
            contact["value"] = true;
          }
        });
      });
    },
    submitExistingContact() {
      let personne;
      const valueContacts = this.contacts.filter((contact) => contact.value === true);
      valueContacts.forEach((p) => {
        personne = {
          id_personne: p.id_personne,
          nom: p.nom,
          prenom: p.prenom,
          civilite: p.civilite,
          email: p.email,
          telephone: p.telephone,
        };
        this.personneToAdd.push(personne);
      });
      const prop_personnes = this.personnes.filter((person) => person.id_personne === undefined);
      prop_personnes.forEach((pers) => {
        this.personneToAdd.push(pers);
      });
      this.$emit('emitPersonnes', this.personneToAdd);
      this.disableButton(this.personneToAdd.length);
      this.personneToAdd = [];
      this.dialogExisting = false;
    },
    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.dialog = false;
        this.personnes.push({
          civilite: this.personne.civilite,
          prenom: this.personne.prenom,
          nom: this.personne.nom,
          email: this.personne.email,
          telephone: this.personne.telephone,
          fonction: this.personne.fonction,
        });
        this.personne = { civilite: "", nom: "", prenom: "", email: "", telephone: "", fonction: "", menu: false };
        this.$v.$reset();
      }
      if (this.personnes.length >= 4) {
        this.disabled = true;
      } else {
        this.disabled = false;
      }
    },
    nbcontacts() {
      const c = this.contacts.filter((res) => res.value === true);
      const newPersonnes = this.personnes.filter((perso) => perso.id_personne === undefined);
      this.nbcontactsSelected = c.length;
      const length = Number.parseInt(newPersonnes.length) + Number.parseInt(c.length);
      this.disableButton(length, true);
    },
    disableButton(length, checkboxes) {
      if (checkboxes) {
        this.disabledCheckbox = length > 4;
      } else {
        this.personnes.length = length === undefined ? this.personnes.length : length;
        if (this.personnes.length >= 4) {
          this.disabled = true;
          this.disabledExisting = true;
        } else {
          this.disabledExisting = false;
          this.disabled = false;
        }
      }
    },
    deleteItem(item) {
      this.editedIndex = this.personnes.indexOf(item);
      this.editedItem = { ...item };
      this.dialogDelete = true;
    },
    deleteItemConfirm() {
      this.contacts.find((c) => {
        if (c.id_personne === this.personnes[this.editedIndex].id_personne) {
          c.value = false;
        }
      });
      this.personnes.splice(this.editedIndex, 1);
      this.$emit('emitPersonnes', this.personnes);
      this.disableButton();
      this.closeDelete();
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      });
    },
  },
  async created() {
    if (this.mode === "visualisation") {
      this.headers = [
        { text: 'Civilité', align: 'start', value: 'civilite', sortable: false },
        { text: 'Nom', value: 'nom', sortable: false },
        { text: 'Prenom', value: 'prenom', sortable: false },
        { text: 'Fonction', value: 'fonction', sortable: false },
        { text: 'Email', value: 'email', sortable: false },
        { text: 'Telephone', value: 'telephone', sortable: false },
      ];
    }
    await this.getContactEntreprise("", this.$route.params.id_entreprise, 0, "nom", "ASC");
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";

// ── Shared modal card ─────────────────────────────────────────────
.cmodal-card {
  border-radius: 12px !important;
  overflow: hidden;
}

.cmodal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: #0B87BA;
  color: #fff;

  &__left {
    display: flex;
    align-items: center;
    gap: 12px;
  }
}

.cmodal-title {
  font-weight: 700;
  font-size: 0.9rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.selection-badge {
  background: rgba(0, 0, 0, 0.2);
  color: #fff;
  font-weight: 700;
  font-size: 0.78rem;
  padding: 2px 10px;
  border-radius: 20px;
  letter-spacing: 0.04em;
}

// ── Contact picker grid ───────────────────────────────────────────
.contacts-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(170px, 1fr));
  gap: 10px;
  max-height: 320px;
  overflow-y: auto;
  padding: 2px 2px 2px 0;
}

.contact-card {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 8px;
  border: 2px solid #e4e4e4;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;
  background: #fafafa;
  user-select: none;

  &:hover {
    border-color: #0B87BA60;
    background: #f2f9fd;
  }

  &--selected {
    border-color: #0B87BA;
    background: #e8f4fb;
  }

  &__avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.7rem;
    font-weight: 700;
    color: #fff;
    flex-shrink: 0;
  }

  &__name {
    font-size: 0.82rem;
    font-weight: 500;
    color: #333;
    line-height: 1.3;
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__check {
    flex-shrink: 0;
  }
}

.no-contacts {
  text-align: center;
  color: #999;
  padding: 24px 0;
  font-size: 0.9rem;
}

// ── Nouveau contact form ──────────────────────────────────────────
.field-label {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.07em;
  color: #777;
  text-transform: uppercase;
  margin-bottom: 4px;

  .required {
    color: #e53935;
  }
}

.civilite-toggle {
  display: flex;
  gap: 8px;
}

.civilite-btn {
  padding: 7px 22px;
  border-radius: 20px;
  border: 2px solid #ddd;
  background: #fff;
  font-weight: 600;
  font-size: 0.85rem;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s, color 0.15s;
  color: #555;
  outline: none;

  &:hover {
    border-color: #0B87BA;
    color: #0B87BA;
  }

  &--active {
    background: #0B87BA;
    border-color: #0B87BA;
    color: #fff;
  }
}

.error-msg {
  color: #e53935;
  font-size: 0.75rem;
  margin-top: 4px;
}

// ── Misc ──────────────────────────────────────────────────────────
.font_color {
  font-weight: bold;
  color: #ffffff;
}

.font-small {
  font-size: 0.75rem;
}

.btnBold {
  font-weight: bold;
}

.actions {
  padding: 2% 5%;
  font-weight: bold;
  font-size: 1.2em;
}

::v-deep .menu-chips.theme--dark.v-list,
.v-chip.v-chip--clickable.v-chip--no-color.v-chip--pill.v-chip--removable.theme--light.v-size--default,
::v-deep .v-icon.notranslate.v-chip__close.v-icon--link.v-icon--right.mdi.mdi-delete.theme--light {
  background: $background-color-blue;
  color: #fff;
}
</style>
